module.exports = __webpack_public_path__ + "img/sms-preview.d93f485f.png";